import {
  fetchMiniGameAwardList,
  fetchMiniGameGetMiniGame,
  fetchMiniGameHistory,
  fetchMiniGameListWinner,
  fetchMiniGameMissions,
  fetchMiniGamePieceCollected,
  fetchMiniGamePrizeCollection,
  fetchMiniGameRanking,
  fetchMiniGameRules,
  fetchMiniGameSpinHistory,
  fetchMiniGameSpinUser,
  fetchMiniGameWinnerList,
} from "@api/miniGame";

export const miniGameKeys = {
  all: ["miniGame"],
  spinUser: ["miniGame", "spinUser"],
  spinHistory: (params) => ["miniGame", "spinHistory", params],
  missions: ["miniGame", "missions"],
  getMiniGame: ["miniGame", "getMiniGame"],
  listWinner: ["miniGame", "listWinner"],
  awardList: ["miniGame", "awardList"],
  ranking: ["miniGame", "ranking"],
  rules: ["miniGame", "rules"],
  config: ["miniGame", "config"],
  prizeCollection: ["miniGame", "prizeCollection"],
  pieceCollected: (params) => ["miniGame", "pieceCollected", params],
  history: (params) => ["miniGame", "history", params],
  winnerList: (params) => ["miniGame", "winnerList", params],
};

const pickData = (res) => res?.data ?? res ?? [];

export const getMiniGameSpinUserQuery = () => ({
  queryKey: miniGameKeys.spinUser,
  queryFn: async () => pickData(await fetchMiniGameSpinUser()),
});

export const getMiniGameSpinHistoryQuery = (params = {}) => ({
  queryKey: miniGameKeys.spinHistory(params),
  queryFn: async () => pickData(await fetchMiniGameSpinHistory(params)),
});

export const getMiniGameMissionsQuery = () => ({
  queryKey: miniGameKeys.missions,
  queryFn: async () => pickData(await fetchMiniGameMissions()),
});

export const getMiniGameGetMiniGameQuery = () => ({
  queryKey: miniGameKeys.getMiniGame,
  queryFn: async () => pickData(await fetchMiniGameGetMiniGame()),
});
export const getMiniGameListWinnerQuery = (type) => ({
  queryKey: ["winner-list", type],
  queryFn: async () =>
    pickData(await fetchMiniGameListWinner({ type })),
});

export const getMiniGameAwardListQuery = () => ({
  queryKey: miniGameKeys.awardList,
  queryFn: async () => pickData(await fetchMiniGameAwardList()),
});

export const getMiniGameRankingQuery = () => ({
  queryKey: miniGameKeys.ranking,
  queryFn: async () => pickData(await fetchMiniGameRanking()),
});

export const getMiniGameRulesQuery = () => ({
  queryKey: miniGameKeys.rules,
  queryFn: async () => pickData(await fetchMiniGameRules()),
});

export const getMiniGamePrizeCollectionQuery = () => ({
  queryKey: miniGameKeys.prizeCollection,
  queryFn: async () => pickData(await fetchMiniGamePrizeCollection()),
});

export const getMiniGamePieceCollectedQuery = (params = {}) => ({
  queryKey: miniGameKeys.pieceCollected(params),
  queryFn: async () => pickData(await fetchMiniGamePieceCollected(params)),
});

export const getMiniGameHistoryQuery = (params = {}) => ({
  queryKey: miniGameKeys.history(params),
  queryFn: async () => pickData(await fetchMiniGameHistory(params)),
});

export const getMiniGameWinnerListQuery = (params = {}) => ({
  queryKey: miniGameKeys.winnerList(params),
  queryFn: async () => pickData(await fetchMiniGameWinnerList(params)),
});
